import React, { useState, useEffect } from 'react';
import { advertisementService } from '../services/advertisementService';
import '../styles/AdvertisementVideo.css';

const AdvertisementVideo = ({ position = 'banner' }) => {
  const [advertisement, setAdvertisement] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAdvertisement();
  }, [position]);

  const fetchAdvertisement = async () => {
    setLoading(true);
    const response = await advertisementService.getActiveAdvertisements(position);
    if (response.success && response.advertisements.length > 0) {
      // Prendre la première publicité active
      const ad = response.advertisements[0];
      setAdvertisement(ad);
      // Enregistrer la vue
      if (ad._id) {
        await advertisementService.trackView(ad._id);
      }
    }
    setLoading(false);
  };

  const getYouTubeVideoId = (url) => {
    if (!url) return null;
    
    // Formats YouTube supportés :
    // https://www.youtube.com/watch?v=VIDEO_ID
    // https://youtu.be/VIDEO_ID
    // https://www.youtube.com/embed/VIDEO_ID
    // https://youtube.com/watch?v=VIDEO_ID
    
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /youtube\.com\/.*[?&]v=([^&\n?#]+)/,
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        return match[1];
      }
    }
    return null;
  };

  const isYouTubeLink = (url) => {
    if (!url) return false;
    return url.includes('youtube.com') || url.includes('youtu.be');
  };

  const isVideoFile = (url) => {
    if (!url) return false;
    const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi'];
    return videoExtensions.some(ext => url.toLowerCase().includes(ext));
  };

  if (loading) {
    return (
      <div className="advertisement-video loading">
        <div className="video-loading">Chargement...</div>
      </div>
    );
  }

  if (!advertisement || !advertisement.imageUrl) {
    return null;
  }

  const videoUrl = advertisement.imageUrl; // On utilise imageUrl pour stocker l'URL de la vidéo
  const youtubeVideoId = getYouTubeVideoId(videoUrl);

  return (
    <div className="advertisement-video">
      <div className="video-container">
        {advertisement.title && (
          <h3 className="video-title">{advertisement.title}</h3>
        )}
        
        <div className="video-wrapper">
          {isYouTubeLink(videoUrl) && youtubeVideoId ? (
            <iframe
              src={`https://www.youtube.com/embed/${youtubeVideoId}?rel=0&modestbranding=1`}
              title={advertisement.title || 'Vidéo publicitaire'}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="video-iframe"
            />
          ) : isVideoFile(videoUrl) ? (
            <video
              controls
              className="video-element"
              poster={advertisement.linkUrl || undefined} // Utiliser linkUrl pour le poster si disponible
            >
              <source src={videoUrl} type="video/mp4" />
              <source src={videoUrl} type="video/webm" />
              Votre navigateur ne supporte pas la lecture de vidéos.
            </video>
          ) : (
            <div className="video-error">
              <p>Format de vidéo non supporté. Veuillez utiliser un lien YouTube ou un fichier vidéo (.mp4, .webm, etc.)</p>
              {videoUrl && (
                <a href={videoUrl} target="_blank" rel="noopener noreferrer" className="video-link">
                  Ouvrir le lien
                </a>
              )}
            </div>
          )}
        </div>

        {advertisement.linkUrl && (
          <div className="video-footer">
            <a
              href={advertisement.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="video-cta"
              onClick={async () => {
                if (advertisement._id) {
                  await advertisementService.trackClick(advertisement._id);
                }
              }}
            >
              En savoir plus →
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdvertisementVideo;





